/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Current } from "./modelCurrent";

class ControllerCurrent extends ControllerModel {
  constructor() {
    super("ControllerCurrent");
    
    this.setNewNode = (callback, location) => {
      let current = new Current(location);
      current.decorate(callback);
      this.addNode(current);
      SingletonFlowchart.SaveStatus()
    }

    this.loadNode = (node, callback) => {
      let current = new Current();
      current.copyFrom(node)
      current.decorate(callback)
      this.addNode(current);
    }

    this.getProperties = async (node) => {
      let n = new Current();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Current();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerCurrent };
